import { computed, Injectable, signal } from '@angular/core';
import { ICarouselItem } from '../models';
import { NmWebSection } from '../../../shared/models/nm-webs.interfaces';
import { ENmWebElementTypes, ENmWebSectionTypes } from '../../../shared/constants/nm-webs.enums';
import { getSectionElementContent } from '../utils/sections.util';
import { Offer } from '../../../shared/models/offers.model';
import { HomeTab, TABS_DATA } from '../constants';
import { parseCmsSectionToTabData } from '../utils/tabs.util';

@Injectable()
export class HomeState {
  private readonly _banners = signal<ICarouselItem[]>([]);
  private readonly _isBannersLoading = signal(false);
  private readonly _webSections = signal<NmWebSection[]>([]);
  private readonly _flightOffers = signal<Offer[]>([]);
  private readonly _isOffersLoading = signal(false);
  private readonly _selectedTabIndex = signal(HomeTab.FLIGHTS);

  readonly banners = this._banners.asReadonly();
  readonly isBannersLoading = this._isBannersLoading.asReadonly();
  readonly webSections = this._webSections.asReadonly();
  readonly flightOffers = this._flightOffers.asReadonly();
  readonly isOffersLoading = this._isOffersLoading.asReadonly();
  readonly selectedTabIndex = this._selectedTabIndex.asReadonly();

  readonly featuredLinksSection = computed(() =>
    this.webSections().find((s) => s.nmGenericType.name === ENmWebSectionTypes.SECTION_LINKS)
  );

  readonly featuredLinksTitle = computed(() =>
    getSectionElementContent(this.featuredLinksSection(), ENmWebElementTypes.ELEMENT_TITLE)
  );

  readonly featuredLinksSubtitle = computed(() =>
    getSectionElementContent(this.featuredLinksSection(), ENmWebElementTypes.ELEMENT_TEXT)
  );

  private readonly homeTabs = computed(
    () => {
      const section = this.webSections().find(
        (s) => s.nmGenericType.name === ENmWebSectionTypes.SECTION_HOME_TABS
      );

      if (!section) return [];

      return parseCmsSectionToTabData(section);
    },
    {
      equal: (a, b) => JSON.stringify(a) === JSON.stringify(b),
    }
  );

  readonly displayHomeTabs = computed(() => [...TABS_DATA, ...this.homeTabs()]);

  setBanners(value: ICarouselItem[]) {
    this._banners.set(value);
  }

  setBannersLoading(value: boolean) {
    this._isBannersLoading.set(value);
  }

  setWebSections(value: NmWebSection[]) {
    this._webSections.set(value);
  }

  setFlightOffers(value: Offer[]) {
    this._flightOffers.set(value);
  }

  setOffersLoading(value: boolean) {
    this._isOffersLoading.set(value);
  }

  setSelectedTabIndex(value: number) {
    this._selectedTabIndex.set(value);
  }
}
